import React, { Component } from "react";
import { connect } from "react-redux";
import { NEW_IMAGE_PATH } from "Constants";
import { Row, Col } from "react-bootstrap";
import Button from "react-bootstrap-button-loader";
import _ from "lodash";
import CheckoutDialog from "./checkout";
import ContactUs from "./contactus.js";
import PublishListItem from "./publish-list-item.js";
import { updateEvent, fetchEvent } from "ActionsMessage";
import PublishContentListItem from "./publish-content-item.js";
import LocaleStrings from "Languages";
import {
  openCheckoutModal,
  updateCheckoutDetails,
  fetchGlobalCount,
  openContactUsModal,
} from "CheckoutAction";
var Loader = require("react-loaders").Loader;

class Publish extends Component {
  constructor(props) {
    super(props);

    /*

    [
      {icon:'publish_business_pro',content:'All in the Business Pro, and below',details:''},
      {icon:'publish_white_labeled',content:'White-labeled apps',details:'Have your own branding and own apps'},
      {icon:'publish_custom_branded',content:'Custom branded iOS / Android apps',details:'Apps are launched with your brand name on the store'},
      {icon:'publish_dedicated_account',content:'Dedicated Account Manager',details:'Our account manager will setup the entire event for you.'},
      {icon:'publish_unlimited_users',content:'Unlimited users',details:'For large events'},
      {icon:'publish_priority_email_',content:'Priority Email Support',details:'Priority support by dedicated account manager'},
      {icon:'publish_qr_scanning',content:'Exhibitor QR scanning / Address book',details:'Exhibitors able to scan visitors for an address book'},
      {icon:'publish_multiple_events',content:'Multiple Events possible',details:'Multiple events under same app'},
      {icon:'publish_party_analytics',content:'Custom 3rd Party Analytics',details:'Google Analytics, Flurry, or any 3rd Party of your choice'},
      {icon:'publish_discounts',content:'Discounts on bulk events',details:'Ask for more discount for multiple events'},
    /*{icon:'publish_additional_language',content:'Additional Language Support',details:'An additional language support of your choice.'}]};
    */

    this.state = {
      loading: true,
      loadingmsg: "",
      starter_pack: [
        {
          icon: "publish_event_details_description",
          content: LocaleStrings.publish_text_starter_pack_content1,
          details: LocaleStrings.publish_text_starter_pack_details1,
        },
        {
          icon: "publish_app_web_branding",
          content: LocaleStrings.publish_text_starter_pack_content2,
          details: LocaleStrings.publish_text_starter_pack_details2,
        },
        {
          icon: "publish_modules_app_web",
          content: LocaleStrings.publish_text_starter_pack_content3,
          details: LocaleStrings.publish_text_starter_pack_details3,
        },
        {
          icon: "publish_add_event_information",
          content: LocaleStrings.publish_text_starter_pack_content4,
          details: LocaleStrings.publish_text_starter_pack_details4,
        },
        // {icon:'publish_pro_website_themes',content:LocaleStrings.publish_text_starter_pack_content5,details:LocaleStrings.publish_text_starter_pack_details5},
        // {icon:'publish_event_ticketing',content:LocaleStrings.publish_text_starter_pack_content6,details:LocaleStrings.publish_text_starter_pack_details6},
        {
          icon: "publish_import_attendee_list",
          content: LocaleStrings.publish_text_starter_pack_content7,
          details: LocaleStrings.publish_text_starter_pack_details7,
        },
        {
          icon: "publish_live_polls_qa",
          content: LocaleStrings.publish_text_starter_pack_content8,
          details: LocaleStrings.publish_text_starter_pack_details8,
        },
        {
          icon: "publish_push_notification",
          content: LocaleStrings.publish_text_starter_pack_content9,
          details: LocaleStrings.publish_text_starter_pack_details9,
        },
        {
          icon: "publish_insightful_event_analytics",
          content: LocaleStrings.publish_text_starter_pack_content10,
          details: LocaleStrings.publish_text_starter_pack_details10,
        },
      ],
      business_pro: [
        {
          icon: "publish_event_publishing",
          content: LocaleStrings.publish_text_business_pro_content1,
          details: LocaleStrings.publish_text_business_pro_details1,
        },
        {
          icon: "publish_tag_based",
          content: LocaleStrings.publish_text_business_pro_content2,
          details: LocaleStrings.publish_text_business_pro_details2,
        },
        {
          icon: "publish_branded_events",
          content: LocaleStrings.publish_text_business_pro_content3,
          details: LocaleStrings.publish_text_business_pro_details3,
        },
        {
          icon: "publish_magic_links",
          content: LocaleStrings.publish_text_business_pro_content4,
          details: LocaleStrings.publish_text_business_pro_details4,
        },
        {
          icon: "publish_content_syncing",
          content: LocaleStrings.publish_text_business_pro_content5,
          details: LocaleStrings.publish_text_business_pro_details5,
        },
        {
          icon: "publish_instant_updates",
          content: LocaleStrings.publish_text_business_pro_content6,
          details: LocaleStrings.publish_text_business_pro_details6,
        },
        {
          icon: "publish_push_notifications",
          content: LocaleStrings.publish_text_business_pro_content7,
          details: LocaleStrings.publish_text_business_pro_details7,
        },
        {
          icon: "publish_engagement_insights",
          content: LocaleStrings.publish_text_business_pro_content8,
          details: LocaleStrings.publish_text_business_pro_details8,
        },
        {
          icon: "publish_regular_email",
          content: LocaleStrings.publish_text_business_pro_content9,
          details: LocaleStrings.publish_text_business_pro_details9,
        },
        {
          icon: "publish_users",
          content: LocaleStrings.publish_text_business_pro_content10,
          details: LocaleStrings.publish_text_business_pro_details10,
        },
      ],
      enterprise_pro: [
        {
          icon: "publish_business_pro",
          content: LocaleStrings.publish_text_enterprise_pro_content1,
          details: LocaleStrings.publish_text_enterprise_pro_details1,
        },
        {
          icon: "publish_white_labeled",
          content: LocaleStrings.publish_text_enterprise_pro_content2,
          details: LocaleStrings.publish_text_enterprise_pro_details2,
        },
        {
          icon: "publish_custom_branded",
          content: LocaleStrings.publish_text_enterprise_pro_content3,
          details: LocaleStrings.publish_text_enterprise_pro_details3,
        },
        {
          icon: "publish_dedicated_account",
          content: LocaleStrings.publish_text_enterprise_pro_content4,
          details: LocaleStrings.publish_text_enterprise_pro_details4,
        },
        {
          icon: "publish_unlimited_users",
          content: LocaleStrings.publish_text_enterprise_pro_content5,
          details: LocaleStrings.publish_text_enterprise_pro_details5,
        },
        {
          icon: "publish_priority_email_",
          content: LocaleStrings.publish_text_enterprise_pro_content6,
          details: LocaleStrings.publish_text_enterprise_pro_details6,
        },
        {
          icon: "publish_multiple_events",
          content: LocaleStrings.publish_text_enterprise_pro_content7,
          details: LocaleStrings.publish_text_enterprise_pro_details7,
        },
        {
          icon: "publish_party_analytics",
          content: LocaleStrings.publish_text_enterprise_pro_content8,
          details: LocaleStrings.publish_text_enterprise_pro_details8,
        },
        {
          icon: "publish_discounts",
          content: LocaleStrings.publish_text_enterprise_pro_content9,
          details: LocaleStrings.publish_text_enterprise_pro_details9,
        },
      ],
    };
  }

  componentDidMount() {
    this.props.fetchEvent(this.props.session, (response) => {});

    this.props.fetchGlobalCount(this.props.session, (response) => {
      this.setState({ loading: false });
    });
  }

  publishNow() {}

  contactUs() {}

  renderItems = () => {
    var items = _.map(this.props.globalFeatures, (feature) => (
      <PublishListItem
        key={feature.label}
        item={feature}
        history={this.props.history}
      />
    ));
    return items;
  };

  renderLoader = () => {
    return (
      <Loader
        type="line-scale-pulse-out-rapid"
        active
        className="template-loader-div"
      />
    );
  };

  renderStarterPackItems = () => {
    return _.map(this.state.starter_pack, (item, index) => (
      <PublishContentListItem key={index} id={index} item={item} />
    ));
  };

  renderBusinessPlanItems = () => {
    return _.map(this.state.business_pro, (item, index) => (
      <PublishContentListItem key={index} id={index} item={item} />
    ));
  };

  renderEnterprisePlanItems = () => {
    return _.map(this.state.enterprise_pro, (item, index) => (
      <PublishContentListItem key={index} id={index} item={item} />
    ));
  };

  activatePlan = () => {
    var request = { published: 1 };
    this.props.updateEvent(
      this.props.session,
      request,
      (response) => {},
      (error) => {}
    );
  };

  publishNowPerEvent = () => {
    this.props.openCheckoutModal(true);
    this.props.updateCheckoutDetails({
      amount: "24900",
      description: "Payment for Business Plan",
      package: "business_pro",
      email: this.props.user.email,
    }); //this.props.user.email
  };

  publishContactUs = () => {
    //this.props.openContactUsModal(true);
    this.props.openCheckoutModal(true);
    this.props.updateCheckoutDetails({
      amount: "59900",
      description: "Payment for Enterprise Plan",
      package: "enterprise_pro",
      email: this.props.user.email,
    });
  };

  onPublishSwitchChange = () => {};

  render() {
    var { published, packageon } = this.props;
    var { loading, loadingmsg } = this.state;

    var package_desc = LocaleStrings.publish_text_starter_pack;
    if (packageon === "business_pro") {
      package_desc = LocaleStrings.publish_text_business_pro;
    } else if (packageon === "enterprise_pro") {
      package_desc = LocaleStrings.publish_text_enterprise_pro;
    }

    // published == -1, condition checked in retun because published condition not required only one scree will display
    return (
      <div>
        {loading ? (
          <div style={{ textAlign: "center", height: 569, padding: 79 }}>
            <div className="template-loader-container">
              {this.renderLoader()}
              <div className="loader-info">{loadingmsg}</div>
            </div>
          </div>
        ) : (
          <div
            className={
              published == -1 ? "published-maincontainer" : "publish-container"
            }
          >
            <CheckoutDialog />
            <ContactUs />
            {published == -1 ? (
              <div>
                <Row>
                  <Col md={12}>
                    <div className="published-container">
                      <div className="published-header">
                        <Row>
                          <Col md={1} className="published-self-service">
                            <img
                              className="publish-icon"
                              src={`${NEW_IMAGE_PATH}publish/self_service.png`}
                            />
                          </Col>
                          <Col md={2} style={{ paddingTop: 5 }}>
                            <div className="published-active-title">
                              {package_desc}
                            </div>
                            <div className="published-active text-uppercase">
                              {LocaleStrings.active}
                            </div>
                          </Col>
                          <Col md={6}>
                            <div>&nbsp;</div>
                          </Col>
                          {/* <Col md={2} style={{textAlign:'right', paddingRight:10}}>
                        <div className="switch-container">
                          <div className="published-switch-title">Published</div>
                          <div className="published-switch-button">
                            <label className="switch">
                              <input type="checkbox" onChange={this.onPublishSwitchChange} checked/>
                              <span className="slider round"></span>
                            </label>
                          </div>
                        </div>
                      </Col> */}
                        </Row>
                      </div>
                      <div className="published-content">
                        <div className="published-content-title">
                          {LocaleStrings.publish_text_next_step}:
                        </div>
                        <div
                          className="publish-featureWap"
                          style={{ paddingLeft: 25 }}
                        >
                          <ul>{this.renderItems()}</ul>
                        </div>
                      </div>
                    </div>
                    <div
                      className="published-contact-container"
                      style={{ marginTop: 20, padding: 20 }}
                    >
                      <Row>
                        <Col md={9}>
                          <div className="published-contact-title">
                            {LocaleStrings.publish_text_how_can_we_help_you}?
                          </div>
                          <div className="published-contact-desc">
                            {
                              LocaleStrings.publish_text_how_can_we_help_you_sub_title
                            }
                            .
                          </div>
                        </Col>
                        <Col md={3} style={{ textAlign: "right" }}>
                          <Button
                            type="button"
                            className="btn btn-default btn-primary publish-button text-uppercase"
                            onClick={this.contactUs}
                          >
                            {LocaleStrings.button_contact_us}
                          </Button>
                        </Col>
                      </Row>
                    </div>
                  </Col>
                </Row>
              </div>
            ) : (
              <Row>
                <Col md={4} style={{ paddingLeft: 0 }}>
                  <div className="publish-card">
                    <div className="publish-demo-account">
                      <div>
                        <img
                          className="publish-icon"
                          src={`${NEW_IMAGE_PATH}publish/demo_account.png`}
                        />
                      </div>
                      <div className="publish-icon-title">
                        {LocaleStrings.publish_text_starter_pack}
                      </div>
                    </div>
                    <div className="self-title-content">
                      <p className="self-title-content-heading">
                        {LocaleStrings.free}
                      </p>
                      <p className="self-title-content-desc">
                        {LocaleStrings.publish_text_not_sure_about_eventify}?
                        <br />
                        {LocaleStrings.publish_text_not_give_it_a_try}.
                      </p>
                    </div>
                    <div className="self-content">
                      {/* <div><img src={`${NEW_IMAGE_PATH}publish/publish_pay_as_you_go.png`}/>{" "}Pay as you go{" "}<img src={`${NEW_IMAGE_PATH}publish/question_icon.png`}/></div>
                      <div><img src={`${NEW_IMAGE_PATH}publish/publish_audience.png`}/>{" "}Full audience management toolkit{" "}<img src={`${NEW_IMAGE_PATH}publish/question_icon.png`}/></div>
                      <div><img src={`${NEW_IMAGE_PATH}publish/publish_sync.png`}/>{" "}Content sync integrations{" "}<img src={`${NEW_IMAGE_PATH}publish/question_icon.png`}/></div> */}
                      {this.renderStarterPackItems()}
                    </div>
                    {/* <div className="publish-bottom">
                      <div className="publish-button-active">UPGRADE to a PREMIUM account.</div>
                    </div> */}
                  </div>
                </Col>
                <Col md={4} style={{ paddingLeft: 10 }}>
                  <div className="publish-card">
                    <div className="publish-business-pro">
                      <div>
                        <img
                          className="publish-icon"
                          src={`${NEW_IMAGE_PATH}publish/business_pro.png`}
                        />
                      </div>
                      <div className="publish-icon-title">
                        {LocaleStrings.publish_text_business_pro}
                      </div>
                    </div>
                    <div className="self-title-content">
                      <p className="self-title-content-heading">
                        {LocaleStrings.publish_text_rs249_per_event}
                      </p>
                      <p className="self-title-content-desc">
                        {LocaleStrings.publish_text_rs249_per_event_sub_title}
                      </p>
                    </div>
                    <div className="self-content">
                      {this.renderBusinessPlanItems()}
                    </div>
                    {/* <div className="publish-bottom">
                      <Button type="button" className="btn btn-default btn-primary publish-button" onClick={this.publishNowPerEvent}>YOU ARE CURRENTLY ON THIS PLAN</Button>
                    </div> */}

                    {packageon == "business_pro" ? (
                      <div className="publish-bottom">
                        <div className="publish-button-active">
                          {LocaleStrings.publish_text_current_active_plan}
                        </div>
                      </div>
                    ) : null}
                  </div>
                </Col>
                <Col md={4} style={{ paddingLeft: 20 }}>
                  <div className="publish-card">
                    <div className="publish-enterprise-pro">
                      <div>
                        <img
                          className="publish-icon"
                          src={`${NEW_IMAGE_PATH}publish/enterprise_pro.png`}
                        />
                      </div>
                      <div className="publish-icon-title">
                        {LocaleStrings.publish_text_enterprise_pro}
                      </div>
                    </div>
                    <div className="self-title-content">
                      <p className="self-title-content-heading">
                        {LocaleStrings.publish_text_rs599_per_event}
                      </p>
                      <p className="self-title-content-desc">
                        {LocaleStrings.publish_text_rs599_per_event_sub_title}
                      </p>
                    </div>
                    <div className="self-content">
                      {this.renderEnterprisePlanItems()}
                    </div>

                    {packageon == "enterprise_pro" ? (
                      <div className="publish-bottom">
                        <div className="publish-button-active">
                          {LocaleStrings.publish_text_current_active_plan}
                        </div>
                      </div>
                    ) : (
                      <div className="publish-bottom">
                        <Button
                          type="button"
                          className="btn btn-default btn-primary publish-button text-uppercase"
                          onClick={this.publishContactUs}
                        >
                          {LocaleStrings.button_upgrade_plan}
                        </Button>
                      </div>
                    )}
                  </div>
                </Col>
              </Row>
            )}
          </div>
        )}
      </div>
    );
  }
}

function mapStateToProps(state) {
  var eventData = {};
  var published = false;
  var packageon = "free";
  if (state.eventData[0]) {
    eventData = state.eventData[0];
    published = eventData.published;
    packageon = eventData.packageon;
  }

  return {
    session: state.session,
    eventData,
    published,
    packageon,
    user: state.user,
    globalFeatures: state.globalCountData,
  };
}

export default connect(mapStateToProps, {
  openCheckoutModal,
  updateCheckoutDetails,
  updateEvent,
  fetchEvent,
  fetchGlobalCount,
  openContactUsModal,
})(Publish);
